var map = {
	"./bonus-coin.icon.png": 35389,
	"./ch-adventure.icon.png": 55718,
	"./ch-casino.icon.png": 60722,
	"./ch-how-to-play.icon.png": 3329,
	"./ch-live-casino.icon.png": 40942,
	"./ch-offers.icon.png": 10550,
	"./ch-sports.icon.png": 32917,
	"./ch-treasure-chest.icon.png": 50647,
	"./ch-worlds.icon.png": 43079,
	"./coin.icon.png": 74540,
	"./ruby.icon.png": 64629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74155;